import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";
import { useIntercom } from "react-use-intercom";
import SideBar from "../../Sections/SideBar";
import Navbar from "../../Sections/NavBar";
import MobileNav from "../../Sections/MobileNav";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../../../app-store/userSlice";
import httpClient from "../../../custom-hooks/httpClient";

function TransferBankToWallet() {
  const userId = localStorage.getItem("id");

  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();

  const [transferDetails, setTransferDetails] = useState({
    transaction_pin: "",
    wallet_account_number: "",
    transfer_amount: "",
  });

  const [areFieldsSet, setAreFieldsSet] = useState(false);
  const { boot } = useIntercom();

  const handleChange = (e) => {
    setTransferDetails({ ...transferDetails, [e.target.name]: e.target.value });
  };
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsProcessing(true);
    // Set transfer amount to number
    const transfer = {
      ...transferDetails,
      transfer_amount: Number(transferDetails.transfer_amount),
    };
    // Add phone number and platform
    transfer.phone_number = user.phone_number;
    transfer.platform = "web";

    httpClient
      .post(`/transfers/bank-to-wallet`, {
       ...transfer,
      })
      .then(({ status, data }) => {
        setIsProcessing(false);
        if (status === 200) {
          window.location = data.link;
        }
      })
      .catch((err) => {
        setIsProcessing(false);
        console.log(err);
        toast.error(err.response.data.message || "Error initiating transfer");
      });
  };

  useEffect(() => {
    Object.values(transferDetails).includes("")
      ? setAreFieldsSet(false)
      : setAreFieldsSet(true);
  }, [transferDetails]);

  useEffect(() => {
    httpClient
      .get(`/users/${userId}`)
      .then(({ status, data }) => {
        if (status === 200) {
          dispatch(setUser(data.user));
          boot({
            name: `${data.user.first_name} ${data.user.last_name}`,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        // toast.error("Error getting user");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!user) {
    return (
      <div
        className="text-center align-items-center"
        style={{ marginTop: "25%" }}
      >
        <Loader type="Oval" color="#1c743a" />
      </div>
    );
  }

  return (
    <>
      <Navbar dashboard />
      <MobileNav />
      <section>
        <div className="container-fluid">
          <div className="row">
            <SideBar />
            <div className="col-12 col-lg-6 col-xl-8 offset-lg-3 offset-xl-2 py-7 py-lg-9 px-lg-7">
              <h2 className="mb-5 text-primary fw-bold">Bank-to-Wallet Transfer</h2>
              <div className="card shadow h-100 py-2">
                <div className="card-body">
                  <h3 className="card-title text-muted">
                    Fund Your Wallet via Your Bank or Debit Card
                  </h3>
                  <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="receivingWallet">
                        Receiving wallet
                      </label>
                      <select
                        className="form-control"
                        id="receivingWallet"
                        name="wallet_account_number"
                        onChange={handleChange}
                      >
                        <option value="">-- Select receiving wallet --</option>
                        {user.wallets.map((wallet) => (
                          <option value={wallet.account_no} key={wallet.id}>
                            {wallet.name} (&#8358;
                            {Number(wallet.balance).toFixed(2).toLocaleString()}
                            )
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="transferAmount">
                        Amount &#8358;
                      </label>

                      <input
                        id="transferAmount"
                        name="transfer_amount"
                        type="number"
                        className="form-control"
                        placeholder=""
                        title="Numbers only"
                        maxLength="10"
                        required
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="transactionPin">
                        Transaction PIN
                      </label>

                      <input
                        type="password"
                        id="transactionPin"
                        name="transaction_pin"
                        className="form-control"
                        placeholder="e.g 123456"
                        title="Numbers only"
                        maxLength="6"
                        pattern="[0-9]{6}"
                        required
                        onChange={handleChange}
                      />
                    </div>
                    <button
                      type="submit"
                      className="btn w-100 btn-primary"
                      disabled={!areFieldsSet || isProcessing}
                    >
                      Proceed
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TransferBankToWallet;
